import { useKeyboardOpenState } from 'hooks/useKeyboardOpenState';
import { usePrevious } from 'hooks/usePrevious';

/**
 * Returns `true` on the render where the on-screen keyboard transitions from
 * open to closed, and `false` otherwise. Useful for re-running layout that was
 * computed against the keyboard-shrunk viewport once it settles back.
 */
export const useKeyboardJustClosed = (): boolean => {
  const isKeyboardOpen = useKeyboardOpenState();
  const prevIsKeyboardOpen = usePrevious(isKeyboardOpen);

  return Boolean(prevIsKeyboardOpen) && !isKeyboardOpen;
};
